/**
 * Base URL for server-only fetch (Server Actions, Route Handlers).
 * Prefer INTERNAL_API_URL when the API runs on the same host as Next.js so
 * DNS / public TLS / hairpin NAT do not break Node's fetch.
 */
export function getServerApiBase(): string {
  const raw =
    process.env.INTERNAL_API_URL ||
    process.env.API_URL ||
    process.env.NEXT_PUBLIC_API_URL;
  if (!raw?.trim()) {
    throw new Error(
      "Missing API URL: set INTERNAL_API_URL (recommended on server) or NEXT_PUBLIC_API_URL"
    );
  }
  return raw.replace(/\/$/, "");
}
